import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import {
  DenyTakeOverPatientFileLockInput,
  useDenyTakeOverPatientMutation as useDenyTakeOverPatientMutationType,
} from "@/modules/patients/services/__generated__/useDenyTakeOverPatientMutation.graphql"

const denyTakeOverPatientMutation = graphql`
  mutation useDenyTakeOverPatientMutation($input: DenyTakeOverPatientFileLockInput!) {
    denyTakeOverPatientFileLock(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      patientFileLockOutput {
        ...PatientFileLockOutputFragment
      }
    }
  }
`

const useDenyTakeOverPatientMutation = () => {
  const [commit] = useMutation<useDenyTakeOverPatientMutationType>(denyTakeOverPatientMutation)

  return useCallback(
    (input: DenyTakeOverPatientFileLockInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.denyTakeOverPatientFileLock
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}

export { useDenyTakeOverPatientMutation }
